import React, {useEffect, useState} from "react";
import HSort from "../canopia/HSort";
import {findValueInArray, remove2, search2, sort, STRICT} from "../canopia/CanopiaUtils";
import {FormGroup} from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import {TiDeleteOutline} from "react-icons/ti";
import {PageSelector} from "../core/PageSelector";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";
import AdminService from "../../services/admin.service";
import FundScanDetail from "./FundScanDetail";
import Btn from "../canopia/Btn";

export default function ScheduledFundScanList(props) {

    const tgtDataOrig = props.tgtDataOrig;

    const initialSortStatus = {
        "clientId": "asc",
        "clientName": "asc",
        "pfDateFmt": "asc", // "scanDateFmt": "asc",
        "createTimestampFmt": "asc",
        "details": "asc",
        "nbFunds": "asc",
        "nbFundsNoCov": "asc",
        "nbFundsAtDate": "asc",
        "nbFunds3Months": "asc",
        "nbFundsOlder": "asc"
    }

    const SEARCH_PROPS = ["clientId", "clientName", "pfDateFmt", // "scanDateFmt",
        "createTimestampFmt", "details", "nbFunds", "nbFundsNoCov", "nbFundsAtDate", "nbFunds3Months", "nbFundsOlder"];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus, sortCol: "clientId",
    }

    const [myState, setMyState] = useState({
        tgtData: tgtDataOrig, // The displayed ones, filtered, sorted, ...

        ...sortAndFilterInitialState
    });

    // Pagination
    const PAGE_SIZE = 50;
    const [page, setPage] = useState(1);

    // Search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [detailHeaders, setDetailHeaders] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [details, setDetails] = useState([]);
    const [showDiff, setShowDiff] = useState(false);

    const colorClass = 'canopia2';
    const pfBgClass = 'background-light';
    const borderLeftClassName = 'border-left';
    const colSizeXL = 300;
    const colWidthXL = colSizeXL + 'px';
    const colSizeL = 122;
    const colWidthL = colSizeL + 'px';
    const colSizeM = 105;
    const colWidthM = colSizeM + 'px';
    const colSizeS = 55;
    const colWidthS = colSizeS + 'px';
    const padding = '0.55em 0.5em';

    useEffect(() => {
        // sortFunc(myState.sortCol);
        filter(showDiff, searchString);
    }, []);

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function changePage(page) {
        setPage(page.key);
    }

    function filter(showDiff, searchString) {
        let newData = [...tgtDataOrig];

        if (showDiff) {
            // Remove all rows containing only zeroes
            newData = remove2([0], newData,
                ["nbFundsDiff", "nbFundsNoCovDiff", "nbFundsAtDateDiff", "nbFunds3MonthsDiff", "nbFundsOlderDiff"],
                STRICT);
        }

        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState = {...myState, tgtData: newData};

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(showDiff, searchString);
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search client, date, ..."
               className={'form-control float-left'}
               style={{minWidth: "280px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
            {searchCategoryInput}
        </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <TiDeleteOutline size={"1.4em"} className={"canopia2"}/>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    let rows;
    let effPage = page;
    let tgtData = myState.tgtData;

    function getDiffNb(nb) {
        return <>({nb > 0 ? <>+{nb}</> : nb})</>;
    }

    function loadDetails(clientId, clientName) {
        setLoadingDetails(true);
        setDetailHeaders({
            clientName: clientName, clientId: clientId
        });
        setShowDetails(true);

        AdminService.loadFundScanDetails(clientId)
            .then((response) => {
                let data = response.data.data;
                let details = data.details;
                // Ref details only exist for the same pf date, null otherwise
                let refDetails = data.refDetails;

                let newDetails = [];
                details.forEach(detail => {
                    let isin = detail.isin;
                    let detailTmp = {...detail};
                    let refDetail = findValueInArray(refDetails, ["isin"], isin);

                    let prevDateFmt;
                    if (refDetail) {
                        prevDateFmt = refDetail.item.curDateFmt
                    }
                    detailTmp["prevDateFmt"] = prevDateFmt;
                    newDetails.push(detailTmp);
                });
                setDetails(newDetails);
            });

        setLoadingDetails(false);
    }

    function hideDetails() {
        setShowDetails(false);
    }

    function handleShowDifferencesOnly(show) {
        filter(show, searchString);
        setShowDiff(show);
    }

    if (tgtData && tgtData.length > 0) {

        let startIndex = (effPage - 1) * PAGE_SIZE;
        if (startIndex >= tgtData.length) {
            effPage = 1;
            startIndex = (effPage - 1) * PAGE_SIZE;
        }
        const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);
        rows = tgtDataAtPage.map(scan => {
            let hasRefDate = scan.hasRefPfDate;
            return <div key={scan.clientId} className={"flex-nowrap border-top setup-row fund-scan-row"}
                        onClick={() => loadDetails(scan.clientId, scan.clientName)}>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.clientId}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthXL, padding: padding}}>
                    <NameTruncWithSearch name={scan.clientName} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={scan.pfDateFmt} maxSize={80} search={searchString} wrap={true}/>
                </div>
                {/*<div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>*/}
                {/*    <NameTruncWithSearch name={scan.scanDateFmt} maxSize={80} search={searchString} wrap={true}/>*/}
                {/*</div>*/}
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <NameTruncWithSearch name={scan.createTimestampFmt} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col right " + borderLeftClassName}
                     style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.nbFunds} {hasRefDate && getDiffNb(scan.nbFundsDiff)}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.nbFundsNoCov} {hasRefDate && getDiffNb(scan.nbFundsNoCovDiff)}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.nbFundsAtDate} {hasRefDate && getDiffNb(scan.nbFundsAtDateDiff)}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.nbFunds3Months} {hasRefDate && getDiffNb(scan.nbFunds3MonthsDiff)}
                </div>
                <div className={"setup-col right"} style={{flexBasis: colWidthM, padding: padding}}>
                    {scan.nbFundsOlder} {hasRefDate && getDiffNb(scan.nbFundsOlderDiff)}
                </div>
                <div className={"setup-col right"} style={{flexGrow: "1", padding: padding}}/>
            </div>;
        });
    }

    const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                       clickFunc={changePage}/>;

    return (<>
        <div className={'border-top background-light'} style={{marginTop: "2rem"}}>
            <div className={"flex-nowrap"}>
                <div className={"setup-th"} style={{flexBasis: "250px"}}>
                    {pageSelector}
                </div>
                <div className={"setup-th-input"} style={{flexBasis: "250px"}}>
                    <div>{searchCategoryComp}</div>
                </div>
                <div className={"setup-th"}>
                    <Btn label={'Different Only'}
                         curClass={showDiff ? 'canopia-nav-btn-active' : 'canopia-nav-btn'}
                         clickFunction={handleShowDifferencesOnly}
                         btnValue={showDiff}
                         doNotTranslate={true}/>
                </div>
            </div>
            <div className={'border-top background-light'}>
                <div className={"flex-nowrap"}>
                    <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>Client Id</b>} colName={'clientId'} state={myState} sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th"} style={{flexBasis: colWidthXL}}>
                        <HSort label={<b>Client Name</b>} colName={'clientName'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                        <HSort label={<b>Src Pf Date</b>} colName={'pfDateFmt'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    {/*<div className={"setup-th"} style={{flexBasis: colWidthL}}>*/}
                    {/*    <HSort label={<b>Target Date</b>} colName={'scanDateFmt'} state={myState} sortFunc={sortFunc}/>*/}
                    {/*</div>*/}
                    <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                        <HSort label={<b>Scan Date</b>} colName={'createTimestampFmt'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th right " + borderLeftClassName} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>Total</b>} colName={'nbFunds'} state={myState} sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th right"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>No LT</b>} colName={'nbFundsNoCov'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th right"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>Up to date</b>} colName={'nbFundsAtDate'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th right"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>1-3 months</b>} colName={'nbFunds3Months'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th right"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>> 3 months</b>} colName={'nbFundsOlder'} state={myState}
                               sortFunc={sortFunc}/>
                    </div>
                </div>
            </div>
        </div>
        {rows}
        <FundScanDetail tgtDataOrig={details} detailHeaders={detailHeaders} show={showDetails} hideFunc={hideDetails}
                        loading={loadingDetails}/>
    </>);
}